var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.9966C12.836 16.9924 12.7169 16.9829 12.6098 16.9616C11.8164 16.8038 11.1962 16.1836 11.0384 15.3902C11 15.197 11 14.9647 11 14.5C11 14.0353 11 13.803 11.0384 13.6098C11.1962 12.8164 11.8164 12.1962 12.6098 12.0384C12.803 12 13.0353 12 13.5 12H28.5C28.9647 12 29.197 12 29.3902 12.0384C30.1836 12.1962 30.8038 12.8164 30.9616 13.6098C31 13.803 31 14.0353 31 14.5C31 14.9647 31 15.197 30.9616 15.3902C30.8038 16.1836 30.1836 16.8038 29.3902 16.9616C29.2831 16.9829 29.164 16.9924 29 16.9966M19 22H23M13 17H29V25.2C29 26.8802 29 27.7202 28.673 28.362C28.3854 28.9265 27.9265 29.3854 27.362 29.673C26.7202 30 25.8802 30 24.2 30H17.8C16.1198 30 15.2798 30 14.638 29.673C14.0735 29.3854 13.6146 28.9265 13.327 28.362C13 27.7202 13 26.8802 13 25.2V17Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.5fd609c6ddca0538d01307b2ee4fec84.svg";
export { ForwardRef as ReactComponent };